import { createRef, Dispatch, SetStateAction, useMemo } from 'react';

import { ReactSelectInstanceRefObject } from '../../custom-react-select.types';
import useOnBlur from '@/utils/use-on-blur';

type Params = {
  selectRef: ReactSelectInstanceRefObject;
  setTabbedIn: Dispatch<SetStateAction<boolean>>;
  setIsFocusedWithin?: Dispatch<SetStateAction<boolean>>;
};

// why? because react select maintains some strange focus when tabbign away
// and we need to ensure that the "edit" text re-appears when hovering with mouse after tabbing away
const useBlurEverythingOnTabAwayFromInput = ({ selectRef, setTabbedIn, setIsFocusedWithin }: Params) => {
  const inputRef = useMemo(() => {
    const _ref = createRef<HTMLInputElement | null>();
    _ref.current = null;
    const inputEl = selectRef?.current?.inputRef;
    if (!inputEl) return _ref;
    _ref.current = inputEl;
    return _ref;
    // need to use selectRef?.current or it won't work
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectRef?.current]);

  useOnBlur({
    ref: inputRef,
    onBlur: () => {
      setTabbedIn(false);
      setIsFocusedWithin?.(false);
    },
  });
};

export default useBlurEverythingOnTabAwayFromInput;
